import { getAuthEnvUrlForPassport } from "./config/env";
export var HOME = "/";
/// /////// Profile Paths
export var profileBasePath = "";
export var pageRoutes = {
    PROFILE_PAGE: "".concat(profileBasePath, "/profile/"),
    PROFILE_EDIT: "".concat(profileBasePath, "/profile/edit"),
    MANAGE_USERS_PAGE: "/account/permissions",
    NAME_EDIT_ROUTE: "/name",
    DESIGNATION_EDIT_ROUTE: "/designation",
    MANAGE_PERMISSIONS_PATH: "/account/manage-permissions/",
    VIEW_PROFILE: "".concat(profileBasePath, "/profile/view/:customerId")
};
/// /////// Invitation Paths
export var invitationBasePath = "/invitation";
export var acceptInvitation = "".concat(invitationBasePath, "/accept");
export var hashPaths = {
    USERS: "#/overview/users",
    OPEN_INVITATIONS: "#/overview/users/invitations",
    DEACTIVATED_USERS: "#/overview/users/deactivated"
};
export var PUMS_AUTHENTICATION_PATH = "user/auth";
export var PUMS_FEDERATE_REDIRECT_CURRENT_PATH = "?origin=".concat(window.location.href);
export var PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH = "?origin=".concat(window.location.origin + pageRoutes.MANAGE_USERS_PAGE);
export var PUMS_NAV_LINK = getAuthEnvUrlForPassport() + PUMS_AUTHENTICATION_PATH + PUMS_FEDERATE_REDIRECT_CURRENT_PATH;
export var PUMS_NAV_MANAGE_USERS_PAGE_LINK = getAuthEnvUrlForPassport() + PUMS_AUTHENTICATION_PATH + PUMS_FEDERATE_REDIRECT_MANAGE_USERS_PAGE_PATH;
export var INTERNAL_LP_DETAILS_PATH = "/logisticsProviders/:lpId";

//# sourceMappingURL=routes.js.map